import React from 'react';

export default function RoleBadge({ roles = [], isActive }) {
  const isAdmin = roles && roles.includes('admin');

  return (
    <>
      <span className={`role-badge ${isAdmin ? 'admin' : 'unverified'}`}>
        {roles && roles.length > 0 ? roles.join(', ') : '—'}
      </span>
      {isActive !== undefined && (
        <span className={`is-active-${isActive ? 'yes' : 'no'}`}>
          ·{isActive ? 'active' : 'disabled'}
        </span>
      )}
    </>
  );
}